import authorize from './modules/authorize'
import app from './modules/app'

const modules = {
  authorize,
  app
}

export default modules
